import { useState, type FC } from 'react';
import SuccessModalWithTimer from '@components/Modals/SuccessModalWithTimer';
import ReviewRulesModal from '@components/Modals/ReviewRulesModal';
import { observer } from 'mobx-react';
import isEmpty from 'lodash/isEmpty';
import ProductCommentBlock from './ProductCommentBlock';
import { HoveredButton, Picture } from '@ui';
import icons from '@icons';
import type { ReviewabilityStatus } from '@schema/cart';
import { useStores } from '@root/src/stores';
import './AddMessageForm.scss';

const {
  qmCircle: { darkGrey: qmCircledDGOutlined, red: qmCircledRedOutlined }
} = icons.Outline;

const {
  info: { black: infoBlackFilled }
} = icons.Fill;

interface DisclaimerProps {
  isQuestion: boolean;
  changeAuthModalState: () => void;
}

const Disclaimer: FC<DisclaimerProps> = observer(
  ({ isQuestion, changeAuthModalState }) => (
    <div
      className={
        'ProductCommentBlock__disclaimer ProductCommentBlock__disclaimer--orange'
      }
    >
      <Picture icon={infoBlackFilled} height='24' />
      <p>
        Чтобы {isQuestion ? 'задать вопрос' : 'добавить отзыв'}, Вы должны{' '}
        <span
          onClick={changeAuthModalState}
          className='ProductCommentBlock__disclaimer__link'
        >
          авторизоваться
        </span>{' '}
        на сайте
      </p>
    </div>
  )
);

interface AddMessageFormProps {
  isQuestion?: boolean;
  reviewabilityStatus: ReviewabilityStatus;
  formPlaceholder;
  onSuccessfullMessageSend;
  changeTabToComments;
  objectId;
  addCommentInstance;
  commentType;
  productId;
  title;
  isShowReviewRules;
  modalSuccessText;
  modalSuccessTitle;
  withReturnForm: boolean;
  isProductAvailableForRefund: boolean;
  isVesovoi: boolean;
}

const AddMessageForm: FC<AddMessageFormProps> = observer(
  ({
    reviewabilityStatus,
    formPlaceholder,
    onSuccessfullMessageSend,
    changeTabToComments,
    objectId,
    addCommentInstance,
    commentType,
    productId,
    title,
    isShowReviewRules,
    isQuestion = false,
    modalSuccessText,
    modalSuccessTitle,
    withReturnForm,
    isProductAvailableForRefund,
    isVesovoi
  }) => {
    const { modalsStore, userStore } = useStores();
    const { user } = userStore;
    const [isReviewRulesModalOpened, setIsReviewRulesModalOpened] =
      useState(false);

    const {
      showCompleteModal,
      changeCompleteModalState,
      changeAuthModalState
    } = modalsStore;
    if (isEmpty(user)) {
      return (
        <Disclaimer
          isQuestion={isQuestion}
          changeAuthModalState={changeAuthModalState}
        />
      );
    }

    return (
      <div className='mess-container'>
        {showCompleteModal && (
          <SuccessModalWithTimer
            closeModal={changeCompleteModalState}
            title={modalSuccessText}
            text={modalSuccessTitle || 'Комментарий успешно добавлен'}
          />
        )}

        {isReviewRulesModalOpened && (
          <ReviewRulesModal
            onClose={() => {
              setIsReviewRulesModalOpened(false);
            }}
          />
        )}

        {title && (
          <div
            className={`main-mess-header mess-header-add ${
              isShowReviewRules ? 'review' : ''
            }`}
          >
            <div className='additional-heading'>{title}</div>
            {isShowReviewRules && (
              <HoveredButton
                onClick={() => {
                  setIsReviewRulesModalOpened(true);
                }}
                wrapperClassName='review-rules-modal__trigger'
                icon={qmCircledDGOutlined}
                iconHover={qmCircledRedOutlined}
                text={
                  <p className='review-rules-modal__trigger__text'>
                    Правила{' '}
                    <span className='review-rules-modal__trigger__text review-rules-modal__trigger__text__hide-mobile'>
                      оформления отзывов и вопросов
                    </span>
                  </p>
                }
              />
            )}
          </div>
        )}

        <ProductCommentBlock
          isProductAvailableForRefund={isProductAvailableForRefund}
          formPlaceholder={formPlaceholder}
          addCommentInstance={addCommentInstance}
          commentType={commentType}
          productId={productId}
          changeTabToComments={changeTabToComments}
          user={user}
          objectId={objectId}
          reviewabilityStatus={reviewabilityStatus}
          withReturnForm={withReturnForm}
          onSuccessfullMessageSend={onSuccessfullMessageSend}
          isVesovoi={isVesovoi}
        />
      </div>
    );
  }
);

export default AddMessageForm;
